import React from 'react';
import styles from './ActivityLogTable.module.css';

const ACTION_LABELS = {
  LOGIN: 'Login',
  RECEIPT_CREATED: 'Receipt Created',
  OFFERING_CREATED: 'Offering Created',
  MEMBER_ADDED: 'Member Added',
  PAYMENT_CREATED: 'Payment Created',
};

const ROLE_LABELS = {
  derasar_admin: 'Admin',
  derasar_member: 'Member',
  platform_admin: 'Platform Admin',
  super_admin: 'Super Admin',
};

const formatDetail = (item) => {
  if (!item.metadata) return '—';
  if (item.action === 'RECEIPT_CREATED' && item.metadata.amount != null) {
    return `Rs. ${item.metadata.amount} ${item.metadata.paymentMode || ''}`.trim();
  }
  if (item.action === 'OFFERING_CREATED' && item.metadata.offeredAmount != null) {
    return `Rs. ${item.metadata.offeredAmount}`;
  }
  if (item.action === 'PAYMENT_CREATED' && item.metadata.amount != null) {
    return `Rs. ${item.metadata.amount}`;
  }
  return '—';
};

const formatWhen = (createdAt) => {
  const d = new Date(createdAt);
  return d.toLocaleString('en-IN', {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
};

const ActivityLogTable = ({ items, total, page, pageSize, onPageChange, isSuperAdmin }) => {
  const totalPages = Math.ceil(total / pageSize);
  const colCount = isSuperAdmin ? 7 : 6;

  return (
    <div>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>When</th>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            {isSuperAdmin && <th>Derasar</th>}
            <th>Action</th>
            <th>Detail</th>
          </tr>
        </thead>
        <tbody>
          {items.length === 0 ? (
            <tr>
              <td colSpan={colCount} className={styles.empty}>
                No activity found.
              </td>
            </tr>
          ) : (
            items.map((item) => (
              <tr key={item.id}>
                <td className={styles.when}>{formatWhen(item.createdAt)}</td>
                <td>{item.userName}</td>
                <td className={styles.email}>{item.userEmail || '—'}</td>
                <td className={styles.role}>{ROLE_LABELS[item.userRole] || item.userRole || '—'}</td>
                {isSuperAdmin && <td>{item.derasarName || '—'}</td>}
                <td>{ACTION_LABELS[item.action] || item.action}</td>
                <td className={styles.detail}>{formatDetail(item)}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {totalPages > 1 && (
        <div className={styles.pagination}>
          <button
            className={styles.pageBtn}
            disabled={page === 1}
            onClick={() => onPageChange(page - 1)}
          >
            Prev
          </button>
          <span className={styles.pageInfo}>Page {page} of {totalPages} ({total} total)</span>
          <button
            className={styles.pageBtn}
            disabled={page >= totalPages}
            onClick={() => onPageChange(page + 1)}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default ActivityLogTable;
